import FilterForm from 'components/forms/FilterForm';
import dayjs from 'dayjs';
import { DatePicker, Form, Input, Select } from 'antd';
import { ForumTable } from 'components/forum/ForumTable';
import { HttpError } from '@refinedev/core';
import { IForum } from 'interfaces/forum';
import { forumStatusOptions } from 'constants/admin/forum';
import { useParams } from 'react-router-dom';
import { useTable } from '@refinedev/antd';

interface IFilter {
  title: string;
  status: string;
  startsAt: dayjs.Dayjs;
  endsAt: dayjs.Dayjs;
}

export const ClassroomForum = () => {
  const { id } = useParams();
  const { tableProps, searchFormProps } = useTable<IForum, HttpError, IFilter>({
    resource: `classrooms/${id}/forums`,
    onSearch: ({ title, status, startsAt, endsAt }) => {
      return [
        {
          field: 'filter[by_title]',
          operator: 'eq',
          value: title
        },
        {
          field: 'filter[by_status]',
          operator: 'eq',
          value: status
        },
        {
          field: 'filter[last_post_starts_at]',
          operator: 'eq',
          value: startsAt
        },
        {
          field: 'filter[last_post_ends_at]',
          operator: 'eq',
          value: endsAt
        }
      ];
    }
  });
  return (
    <>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="title">
          <Input placeholder="Título do tópico" />
        </Form.Item>

        <Form.Item name="startsAt">
          <DatePicker
            className="w-full"
            placeholder="Última atualização (a partir de)"
            format="DD/MM/YYYY"
          />
        </Form.Item>

        <Form.Item name="endsAt">
          <DatePicker
            className="w-full"
            placeholder="Última atualização (término em)"
            format="DD/MM/YYYY"
          />
        </Form.Item>

        <Form.Item name="status">
          <Select
            placeholder="Todos status"
            options={forumStatusOptions}
            defaultValue={null}
          />
        </Form.Item>
      </FilterForm>

      <ForumTable tableProps={tableProps} />
    </>
  );
};
